import IdeaDetailPage from './IdeaDetailPage';

export default IdeaDetailPage;
